// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-css/lib/card.css
// module id = 807
// module chunks = 11